// extracted by mini-css-extract-plugin
export default {"headerRow":"G95a0f1","header":"G47abfb","currentAddress":"G89bb18","newAddressLink":"G2cf72f","arrowRight":"G9672c5 G5e65f6 G5a2f5d","spinnerContainer":"Gc901dc","spinner":"G6c942b"};